import {ContentShellViewStyle} from '@levelapp/softfabric';

export default class ShellFaqViewStyle extends ContentShellViewStyle{}